<template lang="html">
<div class="pgInner announcement">

    <div class="headBar">新建应用场景发布</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">标题</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入场景标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">应用场景</div>
                     <div class="bContent">
                           <el-form-item prop="scenes">
                                <el-input size="medium" class="inpText" v-model="params.scenes" placeholder="请输入场景"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">所在地点</div>
                     <div class="bContent">

                           <el-form-item prop="address">
                                  <ads-select :adsList="adsStore" @selected="mapChange"  selectType="1"/>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">推荐单位</div>
                     <div class="bContent">
                           <el-form-item>
                                <el-input size="medium" class="inpText" v-model="params.recommendOrganization" placeholder="请输入推荐单位"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">标签</div>
                     <div class="bContent">
                           <el-form-item prop="tagNames">
                                <tag-select :selectTags="params.tagNames" paramsKey="tagNames" @selectChange="tagChange" />
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">封面图片</div>
                     <div class="bContent">
                           <img-upload :image="params.image" @imgChange="imgChange" tips="（115*70推荐）"/>
                     </div>
                 </div>

                 <div class="text-block scene-block clearfix">
                     <div class="bName">场景需求</div>
                     <div class="bContent">
                        <textEditor ref="textEditor" :inContent="params.content" />
                     </div>
                 </div>

                 <div class="text-block radio-block clearfix">
                     <div class="bName">可见范围</div>
                     <div class="bContent">
                         <el-radio-group v-model="radioType">
                            <el-radio border size="medium" :label="1">全部</el-radio>
                            <el-radio border size="medium" :label="2">指定类型</el-radio>
                            <el-radio border size="medium" :label="3">指定企业</el-radio>
                            <el-radio border size="medium" :label="4">指定用户</el-radio>
                         </el-radio-group>
                     </div>
                 </div>

                 <div class="text-block check-block clearfix">
                     <div class="bName"></div>
                     <div class="bContent">
                         <div v-if="radioType==2">
                             <el-checkbox-group v-model="idArr1">
                                 <el-checkbox v-for="(item,index) in selectList1" :key="index" :label="item.id">{{item.name}}</el-checkbox>
                             </el-checkbox-group>
                         </div>
                         <div v-if="radioType==3" class="check-seek">
                             <div class="seek-head">
                                 <i class="el-icon-search"></i>
                                 <el-select
                                     filterable
                                     remote
                                      @change="handleChange"
                                      :remote-method="entSeek"
                                      :loading="loading1"
                                      v-model="entId"
                                      placeholder="搜索企业名称">

                                     <el-option
                                       v-for="item in selectList2"
                                       :key="item.id"
                                       :label="item.companyName"
                                       :value="item.id">
                                     </el-option>

                                 </el-select>

                                 <el-button @click="entSelect" style="margin-left:12px;" size="medium" type="primary">添加</el-button>
                             </div>
                             <div class="seek-body">
                                 <el-tag
                                   v-for="(item,index) in idArr2"
                                   :key="index"
                                   type="danger"
                                   @close="entRemove(index)"
                                   closable>
                                   {{item.name}}
                                 </el-tag>
                             </div>
                         </div>
                         <div v-if="radioType==4" class="check-seek">
                             <div class="seek-head">
                                 <i class="el-icon-search"></i>
                                 <el-select
                                      filterable
                                      remote
                                      :remote-method="userSeek"
                                      :loading="loading2"
                                      v-model="userId"
                                      placeholder="搜索用户">
                                     <el-option
                                       v-for="item in selectList3"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                                        <span>{{ item.name }}</span>
                                        <span>（{{ item.enterpriseName }}）</span>
                                     </el-option>

                                 </el-select>

                                 <el-button @click="userSelect" style="margin-left:12px;" size="medium" type="primary">添加</el-button>
                             </div>
                             <div class="seek-body">
                                 <el-tag
                                   v-for="(item,index) in idArr3"
                                   :key="index"
                                   type="danger"
                                   @close="userRemove(index)"
                                   closable>
                                   {{item.name}}（{{item.enterpriseName}}）
                                 </el-tag>
                             </div>
                         </div>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

        <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
        <el-button @click="directSave(2)" plain size="small">存为草稿</el-button>
        <el-button @click="goReturn" plain size="small">取消</el-button>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { ancEdit,ancPredat } from "@/api/announcement/announcement";
import { dicSeek } from "@/api/pgMent/dictMent";
import { getEnterpriseList } from "@/api/attes/attestation";
import { getEntUser } from "@/api/enterprise/index";

export default {
    components:{
        Editor
    },
    computed:{
        lineStr:function(){
            var str = '';
            if(this.navAct === 0 || this.navAct == 4){
               str = 'width:60px;';
            }else {
               str =  'width:30px;';
            }

            str = str + "left:" + this.navX + "px;";

            return str;
        }
    },
    data(){
        return{

            idArr1:[],   // 指定类型
            idArr2:[],   // 指定企业
            idArr3:[],   // 指定用户

            radioType:1,
            adsStore:[],

            entId:'',
            entMap:{},
            loading1:false,

            userId:'',
            userMap:{},
            loading2:false,

            selectList1:[],
            selectList2:[],
            selectList3:[],

            pageH:'',
            params:{

                id:'',
                title:'',
                scenes:'',
                address:'',
                recommendOrganization:'',
                longitude:'',
                latitude:'',
                tagNames:'',

                content:'',
                visibleRangeType:'',
                visibleRangeUser:'',
                visibleRangeEnterprise:'',

                type:'',
                image:''

            },

            preCode:'',
            pgName:'',

            rules:{
                title:[{
                      required: true,
                      trigger: 'blur'
                }],
                scenes:[{
                      required: true,
                      trigger: 'blur'
                }],
                address:[{
                      required: true,
                      trigger: 'blur'
                }]
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },
        selectChange:function(eDat){   //  数据字典
            this.params.status = eDat.id;
        },

        contentChange:function(e){    // 富文本内容
            this.params.content = e;
        },

        tagChange:function(e){
            this.params[e.paramsKey] = e.id;
        },

        mapChange:function(e){    //  位置地点
            this.params.address = e.name + ',' + e.id;
            if(e.address){
                this.params.address = this.params.address  + ',' + e.address;
            };
            this.params.latitude = e.latLng.lat;
            this.params.longitude = e.latLng.lng;
        },

        goCreate:function(status){  // 创建
            var vues = this;
            this.params.status = status;
            ancEdit({notice:this.params}).then(res => {
                vues.$router.push('applicationScene');
            }).catch(err => {})
        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate(2);
                    vues.preCode = nowCode;
                }
            },60000)
        },

        directSave:function(status){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    vues.params.content = vues.$refs.textEditor.editorContent;
                    if(!vues.params.content){
                        vues.$message.error('正文内容必须填写！');
                    }else if(!vues.params.image){
                        vues.$message.error('请上传封面图!');
                    }else{
                      vues.$refs.ruleForm.validate((valid) => {
                          if(valid){
                              var arrs = ['visibleRangeType','visibleRangeEnterprise','visibleRangeUser'];
                              if(vues.radioType == 2){
                                  vues.params.visibleRangeType = vues.idArr1.join(',');
                                  vues.params.visibleRangeEnterprise = '';
                                  vues.params.visibleRangeUser = '';
                              }else if(vues.radioType == 3){
                                  let newArr = [];
                                  vues.idArr2.forEach((item, i) => {
                                      let temp = {
                                          id:item.id,
                                          name:item.name,
                                      }
                                      newArr.push(temp);
                                  });
                                  vues.params.visibleRangeType = '';
                                  vues.params.visibleRangeUser = '';
                                  vues.params.visibleRangeEnterprise = JSON.stringify(newArr);
                              }else if(vues.radioType == 4){
                                  let newArr = [];
                                  vues.idArr3.forEach((item, i) => {
                                      let temp = {
                                          id:item.id,
                                          name:item.name,
                                          enterpriseName:item.enterpriseName,
                                      }
                                      newArr.push(temp);
                                  });
                                  vues.params.visibleRangeType = '';
                                  vues.params.visibleRangeEnterprise = '';
                                  vues.params.visibleRangeUser = JSON.stringify(newArr);
                              }


                              vues.goCreate(status);
                          }

                       })
                    }

                }

            })
        },


        imgChange:function(e){
            this.params.image = e;
        },

        entSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              getEnterpriseList({
                 statusList:[1,2,4],
                 keyword:key,
                 sort:2,
                 no:1,
                 size:12
              }).then(res => {
                 vues.selectList2 = res.enterpriseList;
                 res.enterpriseList.forEach((item, i) => {
                     vues.entMap[item.id] = item;
                 });

              })
            }
        },

        entSelect:function(){
            let isSelected = false;
            this.idArr2.forEach((item, i) => {
                if(item.id == this.entId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                this.entMap[this.entId].name = this.entMap[this.entId].companyName;
                this.idArr2.push(this.entMap[this.entId]);
            }else{
                this.$message.error('已添加！');
            }

        },

        entRemove:function(inx){
            this.idArr2.splice(inx,1);
        },

        userSeek:function(e){
          var vues = this;
          var key = e.replace(/\s+/g,'');
          if(key){
            getEntUser({
               statusList:[1],
               keyword:key,
               sort:2,
               no:1,
               size:12
            }).then(res => {
               vues.selectList3 = res.enterprisePersonList;
               res.enterprisePersonList.forEach((item, i) => {
                   vues.userMap[item.id] = item;
               });

            })
          }
        },

        userSelect:function(){
            let isSelected = false;
            this.idArr3.forEach((item, i) => {
                if(item.id == this.userId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                // console.log(this.userMap);
                let temp = {
                    id:this.userMap[this.userId].userId,
                    name:this.userMap[this.userId].name,
                    enterpriseName:this.userMap[this.userId].enterpriseName,
                }
                this.idArr3.push(temp);
                // console.log(this.idArr3);
            }else{
                this.$message.error('已添加！');
            }

        },

        userRemove:function(inx){
            this.idArr3.splice(inx,1);
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;
            this.params.type = querys.typeid;

            // 底部定位
            this.pageFix();

            dicSeek({code:'sflx'}).then(res => {
                this.selectList1 = res.dataDictionarys;
            })

            if(querys && querys.id){
                this.params.id = querys.id;
                ancPredat({id:querys.id}).then(res => {
                    vues.params = res.notice;
                    vues.preCode = JSON.stringify(this.params);

                    // 所在地点
                    this.adsStore = [{
                        name:this.params.address.split(',')[0],
                        id:this.params.address.split(',')[1],
                        address:this.params.address.split(',')[2],
                        latLng:{
                           lng:this.params.longitude,
                           lat:this.params.latitude
                        }
                    }];

                    var arrs = ['visibleRangeType','visibleRangeEnterprise','visibleRangeUser'];
                    arrs.forEach((item, i) => {
                        if(vues.params[item]){
                            vues.radioType = i + 2;
                            let tempArr = [];
                            if(i === 0){
                                tempArr = vues.params[item].split(',');
                            }else{
                                tempArr = JSON.parse(vues.params[item]);
                            };
                            vues['idArr' + (i+1)] = tempArr;
                            console.log(vues);
                        }
                    });
                })
            }

        }

    },
    created:function(){
        var vues = this;

        this.prevSet();
        $(window).on('resize',function(){
            vues.pageFix();
            vues.$refs.scroller.sizeHeight = this.pageH;
        });

    },

    beforeDestroy:function(){
        clearInterval(this.waitSave);
        $(window).off('resize');
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 80px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 80px;
          position: relative;
          .inpText{
               width: 420px;
          }
     }
}

.scene-block{
     margin-top: 20px;
}

.time-block{

     .tips{
          display: inline-block;
          margin-left: 12px;
          font-size: 12px;
          color: #AEAEAE;
     }
}

.radio-block{
     margin-top: 20px;
}

.check-block{
    margin-top: 20px;
   .check-seek {
       .seek-head{
           position: relative;
           .el-icon-search{
               position: absolute;
               left: 15px;
               top: 12px;
               color: #dcdfe6;
               z-index: 2;
           }
           .el-select{
              width: 432px;
           }
       }
       .seek-body{
            .el-tag{
                margin-right: 12px;
                margin-top: 12px;
            }
       }
   }
}

</style>

<style lang="css">

.announcement .el-input__inner{
    border-radius: 0px;
}

.announcement .time-block .el-form-item{
     display: inline-block ;
 }

 .announcement .seek-head .el-input__inner{
     padding-left: 35px !important;
 }
</style>



// WEBPACK FOOTER //
// apcEdit.vue?5a4ab2a0